<template>
    <div class="md-layout-item md-size-100">
        <h3>Location</h3>
        <p class="margin_bottom">Ensure exact location, tweak by clicking new location or dragging the pin (if required use street view to confirm)</p>
        <div class="md-layout-item md-size-100 building-location">
            <div id="googlemap"></div>
        </div>
    </div>
</template>
<script>

    import getCurrentConfig from "@/ts/customConfig";
    import { Loader, LoaderOptions } from "google-maps";
    const loader = new Loader(getCurrentConfig().googleMapsApiKey);

    export default {
        name: "BuildingLocation",  
        props: {
            location: {
                lat: null,
                lng: null
            },
            name : null
        },
        data() {
            return {
                    map: null,
                    marker: null,
                }
        },
        methods: {
            setNewLocation(e, source) {
                var lat = e.latLng.lat();
                var lng = e.latLng.lng();
                this.changeLocation(lat, lng, source);
            },
            changeLocation(lat, lng, source) {
                this.location.lat = lat;
                this.location.lng = lng;
                this.movePinCenterMap(lat, lng);
            },
            movePinCenterMap(lat, lng) {
                var location = new google.maps.LatLng(lat, lng);
                this.marker.setPosition(location);
                this.map.panTo(location);
            }
        },
        mounted() {
            var self = this;
            loader.load().then(function (google) {
                const myLatlng = new window.google.maps.LatLng(self.location.lat, self.location.lng);
                const mapOptions = {
                    zoom: 18,
                    scrollwheel: false, // we disable de scroll over the map, it is a really annoing when you scroll through page
                    center: myLatlng,
                    //mapTypeId: window.google.maps.MapTypeId.SATELLITE
                };

                self.map = new window.google.maps.Map(
                    document.getElementById("googlemap"),
                    mapOptions
                );
                self.marker = new window.google.maps.Marker({
                    position: myLatlng,
                    title: self.name,
                    draggable: true
                });
                self.marker.setMap(self.map);
                window.google.maps.event.addListener(self.marker, 'dragend', evt => { self.setNewLocation(evt, 'Drop') });
                window.google.maps.event.addListener(self.map, 'click', evt => { self.setNewLocation(evt, 'Click') });
                //window.google.maps.event.addDomListener(window, 'resize', initialize); //TODO:TD make it responsive with https://webomnizz.com/how-to-make-responsive-google-map-with-google-map-api/
            });
        }
    }
</script>


<style lang="scss">

   

    
</style>
